const VueI8nService = {
    install: function (Vue/*, options*/) {
        Vue.prototype.$translate = function (content) {
            let languageCode = 'eng';
            return content[languageCode];
        }
    }
}

export default VueI8nService